<template>
    <RoundedContainer>
        <h2 class="has-text-centered p-2">Files</h2>

        <span v-if="tickedFileListNames.length > 0">        
            <LabelledPills
                :labels="tickedFileListNames"
                :defaultClass="pillsClass"
                @delete-clicked="removeTickedFile">
            </LabelledPills>
        </span>

        <span v-else>
            <p class="has-text-centered p-2">Please provide some files</p>
        </span>
    </RoundedContainer>
</template>

<script>
import LabelledPills from '@/widgets/LabelledPills.vue'
import RoundedContainer from '@/widgets/RoundedContainer.vue'
import { popItem } from '@/js/general'

export default {
    name: 'PillsManager',
    components: {LabelledPills, RoundedContainer},
    props: {
        modelValue: {type: Array, default: [],},
        pillsClass: {type: String, required: false},
    },
    emits: ['update:modelValue'],
    computed: {
        tickedFileListNames(){
            return this.modelValue.map(
                (audioFile) => audioFile.file_name
            )
        },
    },
    methods: {
        removeTickedFile(audioFileName){
            for (const audioFile of this.modelValue){
                if (audioFile.file_name === audioFileName){
                    const newList = popItem(
                        audioFile, this.modelValue
                    )
                    this.$emit('update:modelValue', newList)
                }
            }
        },
    }
}
</script>

